import React from "react";
import { View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import Text from "@components/CustomText";
import t from "@constants/localization";
import Photo from "./Photo";
import Comment from "./Comment";
import { kycStyles as s, HALF_TILE } from "./styles";

const PATH = "screens/KYCSetup/UserPhotoSection";

const UserPhotoSection = (props) => {
  const {
    userPhoto = "",
    uploadUserPhoto = () => {},
    removeUserPhoto = () => {},
    disableUserPhotoSection = false,
    verified,
    rejectionComment = null,
    imageHeaders = null,
  } = props;
  const { source = "", localUri = "" } = userPhoto;

  return (
    <View style={s.section}>
      <Comment kycComment={rejectionComment} />
      {verified ? (
        <View style={s.verifiedRow}>
          <CheckIcon fill="rgba(0,171,89,1)" size={18} />
          <Text style={s.verifiedText}>{t(`${PATH}/photoVerified`)}</Text>
        </View>
      ) : (
        <Text style={s.sectionLabel}>
          {t(`${PATH}/uploadPhoto`)}
          {!disableUserPhotoSection && <Text style={s.requiredStar}>*</Text>}
        </Text>
      )}
      <Photo
        source={source}
        previewUri={localUri}
        imageHeaders={imageHeaders}
        disabled={disableUserPhotoSection}
        onUpload={uploadUserPhoto}
        onDelete={removeUserPhoto}
        ctaText={t(`${PATH}/uploadPhoto`)}
        style={{ width: HALF_TILE }}
      />
    </View>
  );
};

export default UserPhotoSection;
